/* ===========================
IMPORTS
=========================== */
import React from 'react';
import PropTypes from 'prop-types';

/* ===========================
CLASS
=========================== */
class CopyToClipboard extends React.Component {
  /* ===========================
  DEFAULT
  =========================== */
  /**
   * componentDidMount
   */
  componentDidMount() {
    document.getElementById('copyToClipboard').select();
    document.execCommand('copy');
    if (this.props.callback) {
      this.props.callback();
    }
  }

  /* ===========================
  RENDER
  =========================== */
  render() {
    return (<input id="copyToClipboard" type="text" defaultValue={this.props.data} style={{ display: 'block' }} />);
  }
}

/* ===========================
PROPERTY TYPES
=========================== */
CopyToClipboard.propTypes = {
  data: PropTypes.object,
  callback: PropTypes.func,
};

/* ===========================
EXPORT
=========================== */
export default CopyToClipboard;
